import * as React from "react";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export default function SelectorSimple1({
  register,
  arreglo,
  getValue2,
  org2,
}) {
  const [age, setAge] = React.useState(org2);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  getValue2(age);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Almacenamiento</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          defaultValue={age}
          value={age}
          label="Age"
          onChange={handleChange}
        >
          <MenuItem value="">
            <option aria-label="None" value="" />
          </MenuItem>

          {arreglo.map((elemento) => (
            <MenuItem value={elemento}> {elemento} </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
